import React, { useRef, useState } from 'react';
import { scanApi } from '../services/api';

// 扫码落地页的图片编辑：给的图只是示例，扫码的人可以删掉、换成自己拍的。
// 发小红书要的是公网 URL，所以本地选的图必须先传到我们的 OSS。
export default function ScanImages({ articleId, images, onChange, onOpen, hint }) {
  const ref = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [err, setErr] = useState('');

  const onFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = '';
    if (!files.length) return;
    setUploading(true);
    setErr('');
    try {
      const next = [...images];
      for (const f of files) {
        const url = await scanApi.uploadImage(articleId, f);
        next.push(url);
        onChange([...next]);
      }
    } catch (e2) {
      setErr(e2?.response?.data?.error || '图片上传失败，请重试');
    } finally {
      setUploading(false);
    }
  };

  const remove = (i) => onChange(images.filter((_, idx) => idx !== i));

  return (
    <div style={s.wrap}>
      <div style={s.row}>
        {images.map((u, i) => (
          <div key={i} style={s.cell}>
            <img src={u} alt="" style={s.img} onClick={() => onOpen && onOpen(images, i)} />
            <span style={s.del} onClick={() => remove(i)}>×</span>
          </div>
        ))}
        <div style={s.add} onClick={() => !uploading && ref.current?.click()}>
          <span style={s.addPlus}>{uploading ? '…' : '+'}</span>
          <span style={s.addText}>{uploading ? '上传中' : '加自己的图'}</span>
        </div>
      </div>
      {hint && <p style={s.hint}>{hint}</p>}
      {err && <p style={s.err}>{err}</p>}
      <input ref={ref} type="file" accept="image/*" multiple style={{ display: 'none' }} onChange={onFiles} />
    </div>
  );
}

const s = {
  wrap: { padding: '0 12px' },
  row: { display: 'flex', flexWrap: 'wrap', gap: 8 },
  cell: { position: 'relative', width: 72, height: 72, borderRadius: 8, overflow: 'hidden', background: '#f0f0f0' },
  img: { width: '100%', height: '100%', objectFit: 'cover', display: 'block' },
  del: {
    position: 'absolute', top: 2, right: 2, width: 20, height: 20, borderRadius: '50%',
    background: 'rgba(0,0,0,0.55)', color: '#fff', fontSize: 15, lineHeight: '20px',
    textAlign: 'center', cursor: 'pointer',
  },
  add: {
    width: 72, height: 72, borderRadius: 8, border: '1.5px dashed #d1d5db', boxSizing: 'border-box',
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    gap: 2, cursor: 'pointer', background: '#fafafa',
  },
  addPlus: { fontSize: 20, color: '#bbb', lineHeight: 1 },
  addText: { fontSize: 10, color: '#9ca3af' },
  hint: { fontSize: 12, color: '#9ca3af', margin: '8px 0 0', lineHeight: 1.6 },
  err: { fontSize: 12, color: '#ef4444', margin: '6px 0 0' },
};
